// Pages
import OpeningBalance from "pages/Accounts/Transaction/OpeningBalance"
import { UpdatePage as UpdateCustomer } from "pages/Card/Transaction/CreateNewCustomer/components/ChildItem/components/Item/components"
import GeneralEntryEdit from "pages/Finance/Transaction/GeneralEntry/Edit"
import EditReceiveMoney from "pages/Finance/Transaction/ReceiveMoney/Edit"
import EditSpendMoney from "pages/Finance/Transaction/SpendMoney/Edit"
import TransferMoneyEdit from "pages/Finance/Transaction/TransferMoney/Edit"
import { CreateNewCustomer } from "pages/Iframe/CreateNewCustomer"
import { CreateNewVendor } from "pages/Iframe/CreateNewVendor"
import { DetailInvoice } from "pages/Iframe/DetailInvoice"
import { UpdateAction } from "pages/Inventori/Transaction/OpeningStock/components/ActionSection"
import EditDepositVendor from "pages/Purchase/Transaction/DepositVendor/Edit"
import EditPurchaseOrder from "pages/Purchase/Transaction/PurchaseOrder/Edit"
import CustomerOrderEdit from "pages/Sales/Transaction/CustomerOrder/Edit"
import CustomerQuotationEdit from "pages/Sales/Transaction/CustomerQuotation/Edit"
import InvoiceEdit from "pages/Sales/Transaction/Invoice/Edit"
import PaymentDepositEdit from "pages/Sales/Transaction/PaymentDeposit/Edit"
import PaymentInvoiceEdit from "pages/Sales/Transaction/PaymentInvoice/Edit"
import EditRejectItem from "pages/Purchase/Transaction/RejectItem/Edit"

// Types
import type { RouteObject } from "react-router-dom"
import ReturnItemsEdit from "pages/Sales/Transaction/ReturnItems/Edit"
import TransferItemsEdit from "pages/Inventori/Transaction/TransferItem/Edit"
import ReceivedEdit from "pages/Inventori/Transaction/Received/Edit"
import { EditAdjustmentInventory } from "pages/Inventori/Transaction/AdjustmentInventory/Edit"
import UpdatePaymentBillPage from "pages/Purchase/Transaction/PaymentBill/UpdatePage"
import { UpdatePaymentBillService } from "pages/Purchase/Transaction/PaymentBillService/UpdatePaymentBillService"
// import CreateNewEmployee from "pages/Card/Transaction/CreateNewEmployee"
import { UpdatePage as UpdateEmployee } from "pages/Card/Transaction/CreateNewEmployee/components/ChildItem/components/Item/components"
import { CreateNewEmployee } from "pages/Iframe/CreateNewEmployee"

export const iframeRoutes: RouteObject[] = [
  { path: "create-customer", element: <CreateNewCustomer /> },
  { path: "create-employee", element: <CreateNewEmployee /> },
  { path: "create-vendor", element: <CreateNewVendor /> },
  { path: "invoice-detail/:id", element: <DetailInvoice /> },
  { path: "customer-update/:id", element: <UpdateCustomer isDetailShop={true} /> },
  { path: "employee-update/:id", element: <UpdateEmployee isIframe /> },

  { path: "spend-money-update/:data_source/:data_source_id", element: <EditSpendMoney /> },
  { path: "receive-money-update/:data_source/:data_source_id", element: <EditReceiveMoney /> },
  { path: "general-entry-update/:data_source/:data_source_id", element: <GeneralEntryEdit /> },
  { path: "transfer-money-update/:data_source/:data_source_id", element: <TransferMoneyEdit /> },

  { path: "purchase-order/:id", element: <EditPurchaseOrder /> },
  { path: "deposit-vendor-update/:deposit_vendor_id", element: <EditDepositVendor /> },

  { path: "opening-balance", element: <OpeningBalance /> },
  { path: "opening-stock-update/:opening_stock_id", element: <UpdateAction /> },

  { path: "customer-order-update/:sales_order_id", element: <CustomerOrderEdit /> },
  { path: "invoice-update/:invoice_id", element: <InvoiceEdit /> },
  { path: "payment-deposit-update/:deposit_customer_id", element: <PaymentDepositEdit /> },
  { path: "payment-invoice-update/:payment_invoice_id", element: <PaymentInvoiceEdit /> },
  { path: "customer-quotation-update/:customer_quotation_id", element: <CustomerQuotationEdit /> },

  { path: "reject-item-update/:bill_id/:reject_id", element: <EditRejectItem /> },
  { path: "return-items-update/:return_id", element: <ReturnItemsEdit /> },
  { path: "transfer-items-update/:transfer_id", element: <TransferItemsEdit /> },
  { path: "received-items-update/:received_id", element: <ReceivedEdit /> },
  { path: "adjustment-inventory-update/:adjustment_id", element: <EditAdjustmentInventory /> },

  { path: "payment-bill-service/:id", element: <UpdatePaymentBillService /> },
  { path: "payment-bill/:payment_bill_id", element: <UpdatePaymentBillPage /> },


];

